export class TokenManager {
  static readonly TOKEN_NAME = 'token';
  static readonly REFRESH_TOKEN = 'refreshToken';
  static readonly TOKEN_ID = 'tokenId';
  static readonly TOKEN = 'token';
  static readonly HEADER_PREFIX = 'Bearer';
  static readonly HEADER_TYPE = 'Authorization';
  static readonly USERNAME = 'username';

  constructor() {}

  static get(key: string = TokenManager.TOKEN_NAME): string | null {
    return window.localStorage.getItem(key);
  }

  static set(token: string, key: string = TokenManager.TOKEN_NAME): void {
    window.localStorage.setItem(key, token);
  }

  static parseToken<T>(key: string = TokenManager.TOKEN_NAME): T | null {
    const token = TokenManager.get(key);
    const tokenId = TokenManager.get(TokenManager.TOKEN_ID);

    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((x) => {
            return '%' + ('00' + x.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );

      return { ...(JSON.parse(jsonPayload) as T), tokenId };
    }

    return null;
  }

  static isExpired(key: string = TokenManager.TOKEN_NAME): boolean {
    const token = TokenManager.parseToken<{ exp: number }>(key);
    return !token || Date.now() + 120_000 >= token.exp * 1000;
  }

  static removeToken(key: string = TokenManager.TOKEN_NAME): boolean {
    const token = TokenManager.get(key);

    if (!token) {
      return false;
    }

    window.localStorage.removeItem(key);
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('tokenType');
    window.localStorage.removeItem(TokenManager.REFRESH_TOKEN);
    window.localStorage.removeItem(TokenManager.TOKEN);
    return true;
  }
}
